import React from 'react'
import { SearchForm } from '../../../Gallery/Search'
import AccountDisplay from '../Account/AccountDisplay'

const DesktopNavigation = ({
  searchTerm,
  handleSearchSubmit,
  handleSearchInput,
  toggleViewFilesMenuVisibility,
  isViewFilesMenuVisible,
  handleNavigation,
  handleDuplicatesClick,
  handleFavoritesClick,
  handleDeletedClick,
  toggleCreateKinCategoryMenuVisibility,
  isCreateKinCategoryMenuVisible,
  handleKinNavigation,
  closeAllMenus,
  handleBuildYourOwnClick,
  isSubNavVisible,
  handleUploadClick,
  toggleAccountMenuVisibility
}) => {
  return (
    <div className="header-content-container">
      <SearchForm
        searchTerm={searchTerm}
        onSearchSubmit={handleSearchSubmit}
        onSearchInput={handleSearchInput}
      />
      <div className="memory-use-display">
        {/* <span>1.57 GB USED</span>  */}
      </div>
      <div className="desktop-nav-container">
        <div className="view-files-dropdown">
          <button
            id="view-files-button"
            className="button-med white shadow01"
            onClick={toggleViewFilesMenuVisibility}
          >
            view gallery
          </button>
          <div
            className={`view-files-nav-pane ${
              isViewFilesMenuVisible ? 'active' : ''
            }`}
          >
            <ul id="view-files-nav" className="shadow04 dropdown-menu">
              <li
                className="desktop-nav-link01"
                onClick={e => handleNavigation(e, '/gallery')}
              >
                photos
              </li>
              <li
                className="desktop-nav-link01"
                onClick={e => handleDuplicatesClick(e)}
              >
                duplicates
              </li>
              <li
                className="desktop-nav-link01"
                onClick={e => handleFavoritesClick(e)}
              >
                favorites
              </li>
              <li
                className="desktop-nav-link01"
                onClick={e => handleDeletedClick(e)}
              >
                deleted
              </li>
            </ul>
          </div>
        </div>
        <div className="create-category-dropdown">
          <button
            id="create-kin-cat-button"
            className="button-med primary create-kin"
            onClick={toggleCreateKinCategoryMenuVisibility}
          >
            create-a-kin-category
          </button>
          <div
            className={`create-a-kin-category-pane ${
              isCreateKinCategoryMenuVisible ? 'active' : ''
            }`}
          >
            <ul id="create-a-kin-category-nav" className="shadow04">
              <li
                className="desktop-nav-link01"
                onClick={e => handleKinNavigation(e, 'Birthday', closeAllMenus)}
              >
                Birthday
              </li>
              <li
                className="desktop-nav-link01"
                onClick={e => handleKinNavigation(e, 'Wedding', closeAllMenus)}
              >
                Wedding
              </li>
              <li
                className="desktop-nav-link01"
                onClick={e =>
                  handleKinNavigation(e, 'Events & Locations', closeAllMenus)
                }
              >
                Events & Locations
              </li>

              <li
                className="desktop-nav-link01 action-nav-link"
                onClick={handleBuildYourOwnClick}
              >
                Build Your Own
                <ul className={`sub-nav ${isSubNavVisible ? 'active' : ''}`}>
                  <li className="desktop-nav-link03 coming-soon ">
                    Friends & Family
                  </li>
                  <li className="desktop-nav-link03 coming-soon">Pets</li>
                  <li className="desktop-nav-link03 coming-soon">
                    Custom Category
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <button
          id="upload-button"
          className="button-med secondary"
          onClick={handleUploadClick}
        >
          upload
        </button>
      </div>
      <AccountDisplay
        toggleAccountMenuVisibility={toggleAccountMenuVisibility}
      />
    </div>
  )
}

export default DesktopNavigation
